import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayMap',
  standalone: true,
})
export class ArrayMapPipe implements PipeTransform {
  transform<T, R>(array: T[], transformFn: (item: T) => R): T[] | R[] {
    if (!Array.isArray(array) || typeof transformFn !== 'function') {
      return array;
    }

    return array.map(transformFn);
  }
}
